import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import { SuccessMessageDialog } from "components/SuccessMessageDialog";

import { MarkBookedOffPlatformFormContainer } from "./MarkBookedOffPlatformFormContainer";

import type { OffPlatformBookingSource } from "./types";

interface Props {
  shipment: ShipperCondensedShipment;
  modalOpen: boolean;
  onModalClose: VoidFunction;
  source: OffPlatformBookingSource;
}

export function MarkBookedOffPlatformModal(props: Props) {
  const { shipment, modalOpen, onModalClose, source } = props;
  const [reportedDialogOpen, setReportedDialogOpen] = useState(false);

  const onReported = () => {
    onModalClose();
    setReportedDialogOpen(true);
  };

  return (
    <>
      <Dialog open={modalOpen} onClose={onModalClose} fullWidth maxWidth="sm">
        <DialogTitle>
          Mark Booked Off Platform
          <IconButton
            aria-label="Close"
            onClick={onModalClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {modalOpen && (
            <MarkBookedOffPlatformFormContainer
              shipment={shipment}
              source={source}
              onReported={onReported}
            />
          )}
        </DialogContent>
      </Dialog>
      <SuccessMessageDialog
        onClose={() => setReportedDialogOpen(false)}
        open={reportedDialogOpen}
        redirect={false}
        dialogBody={
          <Typography variant="h5">
            Thanks! Support has your booking details and will record the carrier
            and the rate for you. This can take up to 24 hours. Once support has
            recorded the booking, the shipment status will change. No further
            action is required from you.
          </Typography>
        }
        buttonVariant="contained"
        buttonLabel="Sounds good!"
      />
    </>
  );
}
